import { useState } from "react";
import CustomButton from "../customs/custom-button";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { ParseErrors } from "../../utils/ParseErrors";
import Loader from "../loader";
import ModalPortal from "../modal-portal";

interface TDeleteAgentModel {
  ToggleDeleteModel: () => void;
  id: number;
}

const DeleteAgentModel = ({ ToggleDeleteModel, id }: TDeleteAgentModel) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteUser = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.delete(`/user/delete/${id}`);
      toast.success(res.data.message);
      setIsLoading(false);
      ToggleDeleteModel();
    } catch (error) {
      console.log(error);
      toast.error(ParseErrors(error));
      setIsLoading(false);
    }
  };

  return (
    <ModalPortal>
      <div
        className="z-[99999] fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center px-4 animate-fade-in"
        onClick={ToggleDeleteModel}
      >
        <div
          className="bg-surface-elevated border border-edge w-full max-w-[500px] rounded-2xl px-6 sm:px-8 py-6 shadow-card"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="font-heading-font text-[24px] sm:text-[30px] text-heading-color leading-tight">
            Are you sure you wanna delete ?
          </h2>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-3 mt-8">
            <CustomButton
              disabled={isLoading}
              className="bg-overlay border border-edge cursor-pointer rounded-lg h-[44px] px-6 font-[400] !text-[16px] text-text-primary hover:bg-overlay-mid transition-colors"
              onClick={() => ToggleDeleteModel()}
            >
              Cancel
            </CustomButton>
            <CustomButton
              disabled={isLoading}
              className="bg-gradient-to-r from-accent to-accent-bright cursor-pointer rounded-lg h-[44px] px-8 font-[400] !text-[16px] text-white shadow-lg shadow-indigo-500/20"
              onClick={deleteUser}
            >
              {isLoading ? <Loader /> : "Delete"}
            </CustomButton>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default DeleteAgentModel;
